"use strict";

function initMap() {
  var map;
  var infowindow;
  var style = [{
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [{
      "color": "#444444"
    }]
  }, {
    "featureType": "administrative.country",
    "elementType": "geometry.fill",
    "stylers": [{
      "hue": "#ff0000"
    }]
  }, {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [{
      "color": "#f2f2f2"
    }]
  }, {
    "featureType": "landscape",
    "elementType": "geometry.fill",
    "stylers": [{
      "color": "#6ca5b9"
    }]
  }, {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [{
      "visibility": "off"
    }]
  }, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{
      "saturation": -100
    }, {
      "lightness": 45
    }]
  }, {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [{
      "visibility": "simplified"
    }]
  }, {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [{
      "visibility": "off"
    }]
  }, {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [{
      "visibility": "off"
    }]
  }, {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{
      "color": "#46bcec"
    }, {
      "visibility": "on"
    }]
  }, {
    "featureType": "water",
    "elementType": "geometry.fill",
    "stylers": [{
      "color": "#ffffff"
    }]
  }];
  map = new google.maps.Map(document.getElementById('map'), {
    center: {
      lat: 47.0781336,
      lng: 2.334548
    },
    zoom: 6,
    styles: style
  });
  displayMarkers(map);
}

function selectMarker(marker) {
  marker.addEventListener("click", function (event) {
    var id = marker.dataset.id;
    var markersContent = document.querySelectorAll('.js-marker-content');
    markersContent.forEach(function (markerContent) {
      markerContent.classList.remove('is-active');

      if (markerContent.getAttribute('data-id') == id) {
        markerContent.classList.add('is-active');
      }
    });

    if (document.querySelector('.marker.selected')) {
      var selected = document.querySelector('.marker.selected');
      selected.style.backgroundColor = selected.getAttribute('data-bg');
      selected.classList.remove('selected');
    }

    marker.style.backgroundColor = '#54585A';
    marker.classList.add('selected');
  });
}

function closeMarker() {
  event.stopPropagation();
  var marker = event.target.closest('.js-marker');
  marker.classList.remove('selected');
  marker.style.backgroundColor = marker.getAttribute('data-bg');
}

function displayMarkers(map) {
  var positions = new Array();

  function HTMLMarker(lat, lng, id, color, name, address, phone, mail, website, map) {
    this.id = id;
    this.lat = lat;
    this.lng = lng;
    this.color = color;
    this.name = name;
    this.address = address;
    this.phone = phone;
    this.mail = mail;
    this.website = website;
    this.pos = new google.maps.LatLng(lat, lng);
    positions.push(this.pos);
    this.setMap(map);
  }

  HTMLMarker.prototype = new google.maps.OverlayView();

  HTMLMarker.prototype.onRemove = function () {
    if (this.div && this.div.parentNode && this.div.parentNode.removeChild) this.div.parentNode.removeChild(this.div);
  };

  HTMLMarker.prototype.getDraggable = function () {};

  HTMLMarker.prototype.getPosition = function () {
    return this.pos;
  };

  HTMLMarker.prototype.onAdd = function () {
    this.div = document.createElement('div');
    this.div.className = "marker js-marker";
    this.div.style.position = 'absolute';
    this.div.style.backgroundColor = this.color;
    this.div.setAttribute('data-id', this.id);
    this.div.setAttribute('data-bg', this.color);
    var panes = this.getPanes();
    panes.overlayImage.appendChild(this.div);
    selectMarker(this.div); // Create infobox

    var infobox = document.createElement('div');
    infobox.className = 'marker-content bg-contain';
    this.div.appendChild(infobox); // Create a div with relative position

    var div = document.createElement('div');
    div.className = 'relative';
    infobox.appendChild(div); // Create close button

    var button = document.createElement('button');
    button.className = 'btn btn-close';
    button.setAttribute('onclick', 'closeMarker()');
    div.appendChild(button); // Infobox's content

    div.innerHTML += '<p class="title">' + this.name + '</p>';
    div.innerHTML += '<p>' + this.address + '</p>';

    if (this.phone) {
      div.innerHTML += '<p>Tel.:' + this.phone + '</p>';
    }

    if (this.fax) {
      div.innerHTML += '<p>Fax.:' + this.fax + '</p>';
    }

    div.innerHTML += '<a href="mailto:' + this.mail + '" title="' + this.mail + '">' + this.mail + '</a>';
    div.innerHTML += '<a href="' + this.website + '" title="' + this.website + '" target="_blank">' + this.website + '</a>';
  };

  HTMLMarker.prototype.draw = function () {
    var overlayProjection = this.getProjection();
    var position = overlayProjection.fromLatLngToDivPixel(this.pos);
    var panes = this.getPanes();
    this.div.style.left = position.x + 'px';
    this.div.style.top = position.y + 'px';
  };

  var markers = locations.map(function (location, i) {
    var htmlMarker = new HTMLMarker(location.lat, location.lng, location.id, location.color, location.name, location.address, location.phone, location.mail, location.website, map);
    return htmlMarker;
  });
  var bounds = new google.maps.LatLngBounds();

  for (var i = 0; i < positions.length; i++) {
    bounds.extend(positions[i]);
  }

  map.fitBounds(bounds);
}